<template>
  <div class="investment-container">
    <img class="bg-img" :src="baseImageUrl + 'bg_1.png'" />
    <div v-if="isMember" class="bg-box">
      <img class="bg-img" :src="baseImageUrl + 'bg_5.png'" />
      <div class="request-title data-title">
        <div class="member-title">
          <span>尊敬的</span>
          <b class="member-name">{{ form.name }}</b>
          <span class="member-post">{{ form.memberPostName }}</span>
        </div>
        <div class="sub-title">您好，欢迎入驻</div>
      </div>
      <div class="info-box info-box-1">
        <div class="cell h100">
          <span class="cell-title">电话：</span>
          <input class="cell-input h100" v-model="form.phone" type="number" maxlength="11" placeholder="请输入" placeholder-class="cell-placeholder" />
        </div>
        <div class="cell h100">
          <span class="cell-title">公司名称：</span>
          <input class="cell-input h100" v-model="form.company" type="span" maxlength="50" placeholder="请输入(选填)" placeholder-class="cell-placeholder" />
        </div>
        <div class="cell h100">
          <span class="cell-title">供货品类：</span>
          <input class="cell-input h100" v-model="form.supplyCategory" type="span" maxlength="20" placeholder="请输入(选填)" placeholder-class="cell-placeholder" />
        </div>
      </div>
    </div>
    <div class="bg-box bg-box--mt">
      <img class="bg-img" :src="baseImageUrl + 'bg_2.png'" />
      <span class="request-title entry-title">
        入驻要求
      </span>
      <div class="detail-box top-0">
        <img class="detail-icon" :src="baseImageUrl + 'detail_icon1.png'" />
        <span class="detail-title h76">商协会企业优先入驻</span>
      </div>
      <div class="detail-box top-1">
        <img class="detail-icon" :src="baseImageUrl + 'detail_icon2.png'" />
        <span class="detail-title">具备价格优势、资证齐全，能够保障48小时内发货</span>
      </div>
      <div class="detail-box top-2">
        <img class="detail-icon" :src="baseImageUrl + 'detail_icon3.png'" />
        <span class="detail-title h76">具备成熟的电商销售经验与团队</span>
      </div>
    </div>
    <div class="bg-box bg-box--mt">
      <img class="bg-img" :src="baseImageUrl + 'bg_3.png'" />
      <span class="request-title data-title">
        入驻资料
      </span>
      <div class="detail-box top-3">
        <img class="detail-icon" :src="baseImageUrl + 'detail_icon4.png'" />
        <div class="detail-title">
          材料准备
          <div class="detail-span">营业执照、公司法人身份证复印件</div>
        </div>
      </div>
      <div class="detail-box top-4">
        <img class="detail-icon" :src="baseImageUrl + 'detail_icon5.png'" />
        <div class="detail-title">
          资质准备
          <div class="detail-span">提交企业生产相关资质</div>
        </div>
      </div>
      <div class="detail-box top-5">
        <img class="detail-icon" :src="baseImageUrl + 'detail_icon6.png'" />
        <div class="detail-title">
          产品报价
          <div class="detail-span">提交贵司的优势产品报价</div>
        </div>
      </div>
    </div>
    <div v-if="!isMember" class="bg-box bg-box--mt bg-box--mt1">
      <img class="bg-img" :src="baseImageUrl + 'bg_4.png'" />
      <div>
        <span class="request-title info-title">
          资料填写
        </span>
        <div class="info-box">
          <span class="info-box-title">您的称呼与联系方式（必填）</span>
          <div class="cell h76">
            <span class="cell-title">姓名：</span>
            <input class="cell-input h76" v-model="form.name" maxlength="20" type="span" placeholder="请输入" placeholder-class="cell-placeholder" />
          </div>
          <div class="cell h100">
            <span class="cell-title">电话：</span>
            <input class="cell-input h100" v-model="form.phone" type="number" maxlength="11" placeholder="请输入" placeholder-class="cell-placeholder" />
          </div>
        </div>
        <div class="info-box info-top1">
          <span class="info-box-title">您的公司名称与经营品类（选填）</span>
          <div class="cell h76">
            <span class="cell-title">公司名称：</span>
            <input class="cell-input h76" v-model="form.company" type="span" maxlength="50" placeholder="请输入" placeholder-class="cell-placeholder" />
          </div>
          <div class="cell h100">
            <span class="cell-title">供货品类：</span>
            <input class="cell-input h100" v-model="form.supplyCategory" type="span" maxlength="20" placeholder="请输入" placeholder-class="cell-placeholder" />
          </div>
        </div>
        <div class="info-box info-top2">
          <span class="info-box-title">您所属的商协会名称（选填）</span>
          <div class="cell h76">
            <span class="cell-title">商协会名称：</span>
            <input class="cell-input h76" v-model="form.chamberName" type="span" maxlength="30" placeholder="请输入" placeholder-class="cell-placeholder" />
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div @click="show = true">
        <span class="share-span">立即分享</span>
        <img class="btn-img" :src="baseImageUrl + 'share_btn.png'" alt="" />
      </div>
      <div @click="onSubmit">
        <span class="submit-span">马上提交</span>
        <img class="btn-img" :src="baseImageUrl + 'submit_btn.png'" alt="" />
      </div>
    </div>

    <van-popup z-index="999" v-model="show" position="bottom" @close="dismiss" closeable round safe-area-inset-bottom>
      <div class="title">分享</div>
      <div class="dialog-content">
        <div class="icon-btn" @click="onShare">
          <img :src="imageUrl + 'mall/share-wechat.png'" class="share-icon" />
          <span class="txt">微信好友</span>
        </div>
        <div class="icon-btn" @click="onPoster">
          <img :src="imageUrl + 'mall/share-post.png'" class="share-icon" />
          <span class="txt">分享海报</span>
        </div>
      </div>
    </van-popup>

    <div class="poster-popup">
      <van-popup v-model="showPoster">
        <div class="poster-popup-content">
          <div class="share-poster-container">
            <img class="share-poster" :src="imageUrl + 'share/ic_share_23_bg.png'" />
          </div>
          <div class="button_save_style_orange" @click="saveAlbumBrowser">
            <img class="download-icon" :src="baseImageUrl + 'download_icon.png'" />
            保存到相册
          </div>
          <img class="close" @click="showPoster = false" :src="imageUrl + 'homepage/icon_post_close.png'" />
        </div>
      </van-popup>
    </div>

    <div class="guide-popup">
      <van-popup v-model="showGuide" style="background-color: transparent;">
        <div class="guide-wrapper">
          <div class="guide-wrapper-content">
            <img class="img" :src="baseImageUrl + 'h5_guide_arrow.png'" alt="">
            <div class="tips">请点击右上角进行分享</div>
            <div class="btn" @click="showGuide= false">我知道了</div>
          </div>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import { addInvestmentSettle, getMemberInfo } from '@/api/data'

import { Toast } from 'vant'
import { Popup } from 'vant'
const imageUrl = 'https://ysh-cdn.kaidicloud.com/test/'
const baseImageUrl = 'https://ysh-cdn.kaidicloud.com/test/h5/investment/'
export default {
  components: {
    [Popup.name]: Popup
  },
  data() {
    return {
      imageUrl,
      baseImageUrl,
      show: false,
      showPoster: false,
      form: {
        name: '',
        phone: '',
        company: '',
        supplyCategory: '',
        chamberName: '',
        memberPostName: ''
      },
      kdOpenId: '',
      isMiniProgram: false,
      isMember: false,
      showGuide: false
    }
  },
  created() {
    document.title = '招商引资'
  },
  mounted() {
    // 判断是否是小程序环境
    this.isMiniProgram = /miniProgram/i.test(navigator.userAgent.toLowerCase())
    // 判断是否登录状态
    const { kdOpenId } = this.$route.query
    this.kdOpenId = kdOpenId || ''
    // 根据kdOpenId查询会员信息
    if (this.kdOpenId) {
      // alert('=== kdOpenId ===:' + this.kdOpenId)
      this.getMemberInfos()
    }
  },
  methods: {
    async getMemberInfos() {
      const res = await getMemberInfo(this.kdOpenId)
      const { data, state } = res.data
      if (state !== 1) return
      if (data && data.name) {
        this.isMember = true
        const { chamberName, memberPostName, name, phone } = data
        Object.assign(this.form, { chamberName, name, phone, memberPostName })
      } else {
        this.isMember = false
      }
    },
    dismiss() {
      this.show = false
      this.showPoster = false
    },

    onShare() {
      if (this.isMiniProgram) {
        // wx.miniProgram.postMessage({ data: { foo: '苹果' } })
        this.show = false
        this.showGuide = true
      } else {
        this.show = false
        Toast({
          message: `<div style="min-width: 96px;padding:8px 8px;font-size:16px;line-height:1.6;">请点击浏览器分享</div>`,
          type: 'html'
        })
      }
    },

    onPoster() {
      if (this.isMiniProgram) {
        this.saveAlbumMiniProgram()
      } else {
        this.showPoster = true
      }
    },

    saveAlbumMiniProgram() {
      const info = {
        imgsrc: imageUrl + 'share/ic_share_23_bg.png'
      }
      wx.miniProgram.navigateTo({
        url: `/subpackage_promoter/pages/promoter-share/index?fromPage=investment&info=${encodeURIComponent(JSON.stringify(info))}`
      })
    },

    saveAlbumBrowser() {
      const imgsrc = imageUrl + 'share/ic_share_23_bg.png'
      let image = new Image()
      image.src = imgsrc
      image.setAttribute('crossOrigin', 'anonymous')
      image.onload = function() {
        let canvas = document.createElement('canvas')
        canvas.width = image.width
        canvas.height = image.height
        let context = canvas.getContext('2d')
        context.drawImage(image, 0, 0, image.width, image.height)
        let url = canvas.toDataURL('image/png') //得到图片的base64编码数据
        let a = document.createElement('a') // 生成一个a元素
        let event = new MouseEvent('click') // 创建一个单击事件
        a.download = '海报' // 设置图片名称没有设置则为默认
        a.href = url // 将生成的URL设置为a.href属性
        a.dispatchEvent(event) // 触发a的单击事件
      }
    },

    async onSubmit() {
      const { name, phone, company, supplyCategory, chamberName } = this.form
      if (!name.trim())
        return Toast({
          message: `<div style="min-width: 96px;padding:6px 8px;font-size:16px;line-height:1.6;">请输入姓名</div>`,
          type: 'html'
        })
      if (!phone.trim())
        return Toast({
          message: `<div style="min-width: 96px;padding:6px 8px;font-size:16px;line-height:1.6;">请输入手机号码</div>`,
          type: 'html'
        })
      if (this.isMiniProgram) {
        if (!this.kdOpenId) {
          wx.miniProgram.navigateTo({
            url: `/pages/login/index?investment=${encodeURIComponent(JSON.stringify(this.form))}`,
          })
          return
        }
        const _investment = {
          name,
          phone,
          company,
          supplyCategory,
          chamberName,
          kdOpenId: this.kdOpenId
        }
        const info = encodeURIComponent(JSON.stringify(_investment))
        wx.miniProgram.redirectTo({
          url: `/subpackage/investment-submit-result/index?info=${info}`,
        })
        return
      }
      const {
        data: { msg, state }
      } = await addInvestmentSettle({
        name,
        phone,
        company,
        supplyCategory,
        chamberName,
        kdOpenId: this.kdOpenId
      })
      if (state !== 1)
        return Toast({
          message: `<div style="min-width: 96px;padding:6px 8px;font-size:16px;line-height:1.6;">${msg}</div>`,
          type: 'html'
        })
      this.$router.push({
        path: '/yyds-investment-success'
      })
    }
  }
}
</script>

<style lang="less" scoped>
.set-box1-top(@n, @i:0) when (@i =< @n) {
  .top-@{i} {
    top: 176px + 116px * @i;
  }
  .set-box1-top(@n, @i + 1);
}
.set-box2-top(@n, @i:3) when (@i =< @n) {
  .top-@{i} {
    top: 160px + 116px * (@i - 3);
  }
  .set-box2-top(@n, @i + 1);
}
.investment-container {
  height: 100vh;
  background-image: url('https://ysh-cdn.kaidicloud.com/test/h5/investment/bg_long.png');
  display: flex;
  flex-direction: column;
  padding-bottom: 120px;
  overflow-y: auto;
}
.bg-img {
  width: 100vw;
  height: auto;
}
.bg-box {
  position: relative;
}
.bg-box--mt {
  margin-top: -40px;
}
.bg-box--mt1 {
  margin-top: -60px;
}
.request-title {
  position: absolute;
  left: 68px;
  color: #000;
  font-weight: 800;
  font-size: 36px;
}
.info-title {
  top: 72px;
}
.entry-title {
  top: 70px;
}

.data-title {
  top: 56px;
}
.sub-title {
  font-size: 32px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000000;
  line-height: 44px;
  margin-top: 12px;
}
.detail-box {
  position: absolute;
  display: flex;
  left: 76px;
  opacity: 1;
  border-bottom: 1px solid #dbdbdb;
  height: 90px;
  // width: calc(100vw - 150px);
  .detail-icon {
    width: 64px;
    height: 64px;
  }
}
.top-2,
.top-5 {
  border-bottom: none;
}
.set-box1-top(3);
.set-box2-top(5);
.detail-title {
  width: 524px;
  align-items: center;
  margin-left: 14px;
  font-size: 28px;
  font-weight: bold;
  line-height: 36px;
  .detail-span {
    font-weight: 400;
    color: #333;
  }
}
.info-box {
  position: absolute;
  top: 170px;
  left: 72px;
  // width: calc(100vw - 150px);
  .info-box-title {
    font-size: 32px;
    font-weight: bold;
    color: #000000;
    line-height: 32px;
  }
  font-size: 28px;
  line-height: 32px;

  .cell {
    width: 600px;
    border-bottom: 1px solid #dbdbdb;
    .cell-title {
      font-weight: bold;
      color: #333333;
    }
    .cell-input {
      float: right;
      text-align: right;
      border: none;
      outline: none;
      background: transparent;
    }
    .cell-placeholder {
      font-weight: 500;
      color: #666666;
    }
  }
}
.info-box-1 {
  top: 200px;
}
.h76 {
  height: 76px;
  line-height: 76px;
}
.h100 {
  height: 100px;
  line-height: 100px;
}
.info-top1 {
  top: 430px;
}
.info-top2 {
  top: 690px;
}
.footer {
  display: flex;
  position: relative;
  margin-left: 26px;
  // width: calc(100vw- 150px);
  font-size: 32px;
  line-height: 32px;
  font-weight: bold;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 999;
  .btn-img {
    width: 342px;
    height: auto;
  }
  .share-span {
    position: absolute;
    left: 108px;
    top: 42px;
    color: #fe7b37;
  }
  .submit-span {
    position: absolute;
    left: 446px;
    top: 42px;
    color: #000;
  }
}
.title {
  font-size: 34px;
  span-align: center;
  color: #222222;
  padding-top: 46px;
}
.dialog-content {
  padding: 64px 126px 0px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.icon-btn {
  width: 150px;
  margin: 0;
  font-size: 24px;
}

.share-btn {
  font-size: 24px;
  background: #fff;
  color: inherit;
}
.share-icon {
  width: 132px;
  height: 132px;
  background-color: transparent;
  border: none;
  margin: 0;
}
.member-title {
  display: flex;
  align-items: center;
  font-weight: 400;
  color: #000000;
}
.member-name {
  margin: 0 6px;
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.member-post {
  min-width: 72px;
  max-width: 150px;
  padding: 0 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 36px;
  text-align: center;
  background: #fcf3f2;
  border-radius: 8px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #fd4e29;
  line-height: 36px;
  margin-left: 8px;
}
.title {
  font-size: 34px;
  text-align: center;
  color: #222222;
  padding-top: 46px;
}
.dialog-content {
  padding: 64px 126px;
}
.icon-btn {
  width: 150px;
  margin: 0;
  font-size: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  .txt {
    margin-top: 12px;
  }
}

.share-btn {
  font-size: 24px;
  background: #fff;
  color: inherit;
}
.share-icon {
  width: 132px;
  height: 132px;
  background-color: transparent;
  border: none;
  margin: 0;
}
.poster-popup-content {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.button_save_style_orange {
  position: relative;
  height: 80px;
  width: 530px;
  background: linear-gradient(90deg, #ff9426 0%, #ff4e00 100%);
  border-radius: 40px;
  margin-top: 48px;
  text-align: center;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 80px;
}
.close {
  width: 56px;
  height: 56px;
  margin-top: 50px;
}
.download-icon {
  position: absolute;
  top: 26px;
  left: 170px;
  width: 22px;
  height: 28px;
}
.poster-popup {
  /deep/ .van-popup {
    background-color: transparent;
  }

  .share-poster-container {
    width: 594px;
    height: 66vh;
    overflow-y: auto;
  }
  .share-poster {
    width: 100%;
    height: auto;
    object-fit: cover;
  }
}
/deep/ .van-popup__close-icon {
  font-size: 48px !important;
}

.guide-wrapper {
  width: 100vw;
  height: 100vh;
  background: transparent;
  position: relative;

  .guide-wrapper-content {
    width: 350px;
    position: absolute;
    right: 150px;
    top: 20px;
    text-align: right;
  }
  .img {
    width: 170px;
    height: 358px;
    
  }
  .tips {
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 44px;
    margin-top: 28px;
  }
  .btn {
    width: 240px;
    height: 72px;
    background: linear-gradient(90deg, #FF9426 0%, #FF4E00 100%);
    border-radius: 44px;
    border: 2px solid rgba(255,255,255,0.9);
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 72px;
    text-align: center;
    margin: 40px auto 0;
  }
}
</style>
